<template>
    <v-card class="mb-5">
        <v-card-text class="pr-2 pl-4 pb-2 pt-4">
            <v-row style="margin: 0 !important">
                <v-col cols="2" class="pl-0 d-flex align-center pt-0">
                    <v-img
                        :src="require('../../../assets/calcBlocks/1.png')"
                    ></v-img>
                </v-col>
                <v-col cols="10" class="pa-0 pt-0 pb-4">
                    <v-row style="margin: 0 !important">
                        <v-col sm="8" md="8" lg="6" cols="6" class="pb-0 pt-0">
                            <div
                                class="
                                    pb-4
                                    pt-2
                                    d-flex
                                    justify-start
                                    align-center
                                    text-headline-small
                                "
                                style="
                                    overflow-wrap: break-word;
                                    word-break: normal;
                                    color: black;
                                "
                            >
                                <v-icon
                                    class="mr-2"
                                    size="x-small"
                                    color="grey-darken-1"
                                >
                                    mdi-vector-polyline mdi-rotate-90
                                </v-icon>
                                <div>
                                    {{ title }}
                                </div>
                            </div>
                            <div
                                class="
                                    text-typography2
                                    pb-4
                                    text-body-large
                                    font-weight-light
                                "
                            >
                                v{{ version }} (latest version)
                            </div>
                        </v-col>
                        <v-col
                            sm="4"
                            md="4"
                            lg="6"
                            class="
                                d-flex
                                justify-end
                                align-start
                                pr-0
                                pb-0
                                pt-0
                            "
                        >
                            <v-lazy v-model="isStatsActive">
                                <CalcStatsChips
                                    class="pr-2"
                                    v-if="showStats && stats.hasStats"
                                    :moveToEnd="true"
                                    :no-left-margin="true"
                                    :manually-set-vals="true"
                                    :manual-loading="stats.loading"
                                    :manual-total-projects="
                                        stats.numberOfProjects.toString()
                                    "
                                    :manual-total-usage="
                                        stats.totalFunctionCalls.toString()
                                    "
                                    :manual-unique-users="
                                        stats.totalUsers.toString()
                                    "
                                />
                            </v-lazy>
                        </v-col>
                    </v-row>
                    <v-row style="margin: 0 !important">
                        <v-col cols="10" class="pt-0">
                            <div
                                style="
                                    font-size: 1rem;
                                    font-weight: 300 !important;
                                    color: black;
                                "
                            >
                                {{ description }}
                            </div>
                        </v-col>
                        <v-col
                            cols="2"
                            class="d-flex justify-end align-end pr-0"
                        >
                            <v-btn
                                class="text-capitalize button"
                                rounded
                                size="small"
                                variant="outlined"
                                :href="href"
                            >
                                Open
                                <v-icon class="icon" color="secondary">
                                    mdi-chevron-right
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script setup>
import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
import CalcStatsChips from '../calc/calc-info/CalcStatsChips.vue'

const props = defineProps({
    library: { type: Object, required: true },
})

const store = useStore()

const showStats = computed(() => store.state.showStats)

const stats = ref({
    hasStats: true,
    loading: true,
    numberOfProjects: 0,
    totalFunctionCalls: 0,
    totalUsers: 0,
})
const isStatsActive = ref(false)

const href = computed(() => `/library/${props.library.libraryId}?path=latest`)
const title = computed(() => props.library.name)
const libraryVersion = computed(() => props.library.libraryVersions[0])
const version = computed(() => libraryVersion.value.version)
const description = computed(() => libraryVersion.value.description)

watch(isStatsActive, async (newVal, oldVal) => {
    if (newVal && !oldVal) {
        store
            .dispatch('getLibrariesStats', [props.library.libraryId])
            .then((res) => {
                if (res.length > 0 && res[0].numberOfProjects !== undefined) {
                    const val = res[0]
                    stats.value.numberOfProjects = compact(val.numberOfProjects)
                    stats.value.totalFunctionCalls = compact(
                        val.totalFunctionCalls
                    )
                    stats.value.totalUsers = compact(val.totalUsers)
                } else {
                    stats.value.hasStats = false
                }
                stats.value.loading = false
            })
    }
})

function compact(number) {
    const formatted = new Intl.NumberFormat('en', {
        notation: 'compact',
        compactDisplay: 'short',
    }).format(number)
    return formatted === 'NaN' ? '0' : formatted
}
</script>
